import { useCallback, useEffect, useState } from 'react';
import {
  LIVE_WEIGHT_DISPLAY_EVENT,
  readLiveWeightDisplayPreference,
  writeLiveWeightDisplayPreference,
} from '../utils/liveWeightDisplayStorage';

/**
 * App-wide live weight strip visibility (localStorage LiveWeightDisplay).
 * Keeps multiple hook instances in sync (AppBar toggle + weighing console).
 */
export function useLiveWeightDisplayPreference() {
  const [enabled, setEnabled] = useState(() => readLiveWeightDisplayPreference());

  useEffect(() => {
    const sync = () => setEnabled(readLiveWeightDisplayPreference());
    const onCustom = (e) => {
      if (typeof e?.detail?.enabled === 'boolean') setEnabled(e.detail.enabled);
      else sync();
    };
    const onStorage = (e) => {
      if (e.key === 'LiveWeightDisplay' || e.key == null) sync();
    };
    window.addEventListener(LIVE_WEIGHT_DISPLAY_EVENT, onCustom);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener(LIVE_WEIGHT_DISPLAY_EVENT, onCustom);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  const setLiveWeightDisplay = useCallback((next) => {
    writeLiveWeightDisplayPreference(Boolean(next));
  }, []);

  const toggleLiveWeightDisplay = useCallback(() => {
    writeLiveWeightDisplayPreference(!readLiveWeightDisplayPreference());
  }, []);

  return { enabled, setLiveWeightDisplay, toggleLiveWeightDisplay };
}
